import React, {memo, useCallback, FC} from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../../store/rootReducer";
import { styled } from "styled-components";

interface Props {
    imageId: number,
    cardId?: string,
}

const Image = styled.img`
    margin: 0 auto;
    display: block;
    max-width: 100%;
`;

const ImageViewerComponent: FC<Props> = (props) => {
    const {imageId, cardId} = props;

    const selector = useCallback((state: RootState) => {
        // Если есть cardId, пытаемся получить URL изображения из карточки
        if (cardId !== undefined && 
            state.cards !== undefined && 
            state.cards[cardId] !== undefined && 
            state.cards[cardId].images !== undefined && 
            state.cards[cardId].images[imageId] !== undefined) {
            return {
                url: `/api/image/${state.cards[cardId].images[imageId]}/`
            };
        }
        
        // Иначе пытаемся получить URL из состояния addCard
        if (state.addCard !== undefined && 
            state.addCard.images !== undefined && 
            state.addCard.images[imageId] !== undefined) {
            return {
                url: state.addCard.images[imageId]
            };
        }
        
        // Если ничего не найдено, возвращаем undefined
        return {
            url: undefined
        };
    }, [imageId, cardId]);

    const {url} = useSelector(selector);

    // Проверяем, что url существует и не null
    if (url !== undefined && url !== null) {
        return <Image
            alt={'image' + imageId}
            src={url} />;
    }

    return null;
};

export const ImageViewer = memo(ImageViewerComponent);
ImageViewer.displayName = 'ImageViewer';
